import { useState } from 'react';

import { Button } from 'antd';
import building from 'assets/icons/building-3.svg';
import check from 'assets/icons/check-circle-fill.svg';
import person from 'assets/icons/person-1.svg';
import { PageTitle } from 'presentation/components/PageTitle';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate } from 'react-router-dom';

const CU00400Page = () => {
    const [isSelectLeft, setIsSelectLeft] = useState<boolean>(false);
    const [isSelectRight, setIsSelectRight] = useState<boolean>(false);
    const navigate = useNavigate();
    const onClick = () => {
        isSelectRight
            ? navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_004_01}`)
            : navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_006_01}`, {
                  state: { editMode: true },
              });
    };
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
            }}
            className="CU-004-00-container"
        >
            <PageTitle title="基本情報の登録" />
            <div className="out-item-select">
                <div style={{ marginBottom: 16 }} className="label">
                    どちらか選択してください。
                </div>

                <div className="out-item-select-area">
                    <div
                        className="item-select-area glow-on-hover"
                        onClick={() => {
                            setIsSelectLeft(!isSelectLeft);
                            isSelectRight === true ? setIsSelectRight(false) : '';
                        }}
                    >
                        {!isSelectLeft || <img src={check} className="check-icon" />}
                        <div className="out-icon-select-area">
                            <div className="building">
                                <img src={building} />
                            </div>
                            <div className="text-select-area">法人</div>
                        </div>
                    </div>

                    <div
                        className="item-select-area glow-on-hover"
                        onClick={() => {
                            setIsSelectRight(!isSelectRight);
                            isSelectLeft ? setIsSelectLeft(false) : '';
                        }}
                    >
                        {!isSelectRight || <img src={check} className="check-icon" />}
                        <div className="out-icon-select-area">
                            <div className="building">
                                <img src={person} />
                            </div>
                            <div className="text-select-area">個人</div>
                        </div>
                    </div>
                </div>

                <div className="button-select-area">
                    <Button
                        className="button-text"
                        type="primary"
                        style={{ width: 343, height: 56 }}
                        disabled={!(isSelectLeft || isSelectRight)}
                        htmlType="submit"
                        onClick={() => onClick()}
                    >
                        次へ
                    </Button>
                </div>
            </div>
        </div>
    );
};
export default CU00400Page;
